import { render, staticRenderFns } from "./About.vue?vue&type=template&id=d92c911a&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=d92c911a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92c911a",
  null
  
)

export default component.exports